import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasCustomer, isStaff, meQuery } from '@/lib/queries';

/**
 * The front door. Staff go straight to the Tab Service area; everyone else to their
 * e-files. The session, when it is already known, decides here, so a staff member never
 * sees the customer screens flash by while the session check runs on the way to /admin.
 */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const me = context.queryClient.getQueryData(meQuery().queryKey);
    throw redirect({ to: me && isStaff(me) && !hasCustomer(me) ? '/admin' : '/e-files' });
  },
});
